import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'rcm-editorial-text-quote',
  styleUrl: 'rcm-editorial-text-quote.scss',
  shadow: true,
})
export class RcmEditorialTextQuote {
  @Prop() quote: string;

  @Prop() author: string;

  @Prop() text: string;

  @Prop() flipped = false;

  render() {
    return (
      <Host>
        <rcm-container>
          <rcm-columns centerChildren={false} class={{ reverse: this.flipped }}>
            <rcm-column span={6}>
              <rcm-headline level={2} headline={this.quote} color="var(--colors-dark-base)" bolditalic></rcm-headline>
              <span class="author">{this.author}</span>
            </rcm-column>
            <rcm-column span={6} class="content">
              <p>{this.text}</p>
            </rcm-column>
          </rcm-columns>
        </rcm-container>
      </Host>
    );
  }
}
